import React from 'react'
import PropTypes from 'prop-types'
import { Eyebrow } from 'components/Typography'
import FormLabel from '../FormLabel'
import FormErrorMessage from '../FormErrorMessage'
import FormQuantitySelectorItem from './FormQuantitySelectorItem'
import { Wrapper } from './FormQuantitySelector.style'

const FormQuantitySelector = ({
  label,
  options,
  required,
  hasError,
  errorMessage,
  isDisabled,
  handleIncrement,
  handleDecrement,
}) => {
  const QuantitySelectorProps = {
    required,
    hasError,
    errorMessage,
    isDisabled,
  }

  return (
    <Wrapper>
      {label && (
        <FormLabel hasError={hasError} isDisabled={isDisabled}>
          <Eyebrow hasError={hasError} color={isDisabled}>
            {label}
          </Eyebrow>
        </FormLabel>
      )}

      {options &&
        options.map((option, index) => {
          const key = `option_${index}`
          return (
            option.available && (
              <FormQuantitySelectorItem
                key={key}
                {...QuantitySelectorProps}
                title={option.label}
                description={option.description}
                handleIncrement={(e) =>
                  handleIncrement(e, option.name, option.value)
                }
                handleDecrement={(e) =>
                  handleDecrement(e, option.name, option.value)
                }
                value={option.value}
                readOnly
              />
            )
          )
        })}

      {hasError && <FormErrorMessage errorMessage={errorMessage} />}
    </Wrapper>
  )
}

FormQuantitySelector.propTypes = {
  label: PropTypes.string,
  options: PropTypes.instanceOf(Object).isRequired,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  handleIncrement: PropTypes.func.isRequired,
  handleDecrement: PropTypes.func.isRequired,
}

FormQuantitySelector.defaultProps = {
  label: '',
  required: false,
  hasError: false,
  errorMessage: '',
  isDisabled: false,
}

export default FormQuantitySelector
